<template>
  <div class="form-group">
    <h3>Step {{ currentStep }}. Your review</h3>
    <div v-if="!allSelected" class="form-row">
      <a href="#" @click.prevent="selectAll">Select All</a>
    </div>
    <div v-for="item in disclaimers" :key="item.id" class="form-row">
      <div class="checkboxlabel" :class="{ on: modelValue[item.id] }" @click="$emit('update:modelValue', { ...modelValue, [item.id]: !modelValue[item.id] })">
        <div class="checkbox" />
        <label>{{ item.label }}</label>
      </div>
    </div>
  </div>
</template>

<script setup>
import { ref } from "vue";

const props = defineProps({
  disclaimers: {
    type: Array,
    required: true,
  },
  currentStep: {
    type: Number,
    required: true,
  },
  modelValue: {
    type: Object,
    default: () => ({}),
  },
});

const emit = defineEmits(["update:modelValue"]);
const allSelected = ref(false);

const selectAll = () => {
  const all = {};
  props.disclaimers.forEach(d => (all[d.id] = true));
  emit("update:modelValue", all);
  allSelected.value = true;
};
</script>
